module.exports = __webpack_public_path__ + "static/media/show.f1e2ef29.png";